import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useSelector } from 'react-redux'
import { Mixpanel } from '../../../config/Mixpanel'
import Constants from '../../../common/constants'

const OwnerButton = ({uploadRef , handlerCertified , handlerPersonalise , setIsActive}) => {

  const cvData = useSelector((store)=> store?.certificateVerification?.cvData);
  const userLinkedIn = useSelector((store) => store?.certificateVerification?.user_linked_url);
   const certifiedData = useSelector((store)=>store?.certificateVerification?.certifiedData);
  const userDetails = useSelector((store) => store?.certificateVerification?.userInfo);
  console.log('button' , uploadRef.current);
  if(cvData && userLinkedIn?.length > 0  ){
  return (
    <button className="w-full rounded-lg bg-[#7FC241] py-3 px-3 text-center text-[16px] md:h-[52px] font-medium text-[#121212] md:text-[18px]" onClick={(e)=>{ Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_BUILD_PERSONALIZED_COURSE_CLICKED);
      
      if(!certifiedData?.is_paid){
          handlerPersonalise({utm_medium : 'build-course' , utm_source : 'certificate-verification'})
          console.log('run')
        }
        else{
          console.log('run1')
        handlerCertified({utm_medium : 'get-certified' , utm_source : 'certificate-verification'})

        }}} >
        Get A Personalised Path For 3x Growth <FontAwesomeIcon icon={faArrowRight} size="md" className='ml-1' />
      </button>
  )
}
else{
    return (
    <button className="w-full rounded-lg bg-[#7FC241] py-3 px-3 text-center text-[16px] md:h-[52px] font-medium text-[#121212] md:text-[18px]" onClick={(e)=> {Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_UPLOAD_CV_AND_LINKEDIN_CLICKED); uploadRef?.current?.scrollIntoView({behavior: "smooth", block: 'center'}) ; setIsActive(true)}}>
        Upload CV & LinkedIn To Land A Job 
      </button>
  )
}
}

export default OwnerButton
